import { createAction } from "@reduxjs/toolkit";

export const API_CALL_BEGAN = createAction("api/API_CALL_BEGAN");
export const API_CALL_SUCCESS = createAction("api/API_CALL_SUCCESS");
export const API_CALL_FAILED = createAction("api/API_CALL_FAILED");
export const AUTH_CALL_BEGAN = createAction("api/AUTH_CALL_BEGAN");
export const AUTH_CALL_SUCCESS = createAction('api/AUTH_CALL_SUCCESS');
export const AUTH_CALL_FAILURE = createAction('api/AUTH_CALL_FAILURE');
